/* FluffCo Holiday Gift Guide — card rendering + shopping logic.
 * Live variant data arrives via window.__ggData (Liquid-emitted from the
 * hidden `holiday-gift-guide` collection); this file holds the page's card
 * configuration (tiers, copy, badges, images, option handling) and the
 * add-to-cart machinery. Sets ("The Guest Register") add multiple items. */
(function () {
  var DATA = (window.__ggData || {}).products || {};
  if (!Object.keys(DATA).length) return;

  var CDN = '/cdn/shop/t/166/assets/';
  var IMG = {
    'hotel-slippers': CDN + 'HotelSlippers_1_0d5de69f.webp',
    'hotel-pillowcase-set-3': CDN + 'fluffco-pillowcase-set-folded-tan-bg-1-v2.webp',
    'pillow-protectors': CDN + 'fc-xp2-protector-4.webp',
    'room-spray-1': CDN + 'RoomSpray_1_783063cd.png',
    'linen-spray': CDN + 'LinenSpray_1_d712dcac.png',
    'silk-eyemask': CDN + 'fluffco-silk-eyemask-cream-flat-v2.webp',
    'hotel-towel': CDN + 'HotelTowel_1_780227d3.webp',
    'travel-pillow': CDN + 'travel-tile-tan.webp',
    'kids-pillow': CDN + 'kids-tile-tan-v2.webp',
    'down-alternative-pillow-1': CDN + 'fluffco-down-alternative-pillow-tan-tile_df979215.webp',
    'down-feather-pillow': CDN + 'fluffco-down-feather-pillow-tan-tile_fd0aba65.webp',
    'neck-pain-pillow': CDN + 'NeckPainPillow_PDP_New1_7609ff37.webp',
    'silk-pillowcase': CDN + 'fluffco-silk-pillowcase-ivory-flat-v2.webp',
    'hotel-waffle-robe': CDN + 'HotelWaffleRobe_1_142fb37a.webp',
    'hotel-lounge-robe': 'https://cdn.shopify.com/s/files/1/0434/5017/1553/files/robes-s-m-hotel-lounge-robe-fluffco-hotel-pillows-42065471471910.png?v=1752837079',
    'flat-fitted-sheet': CDN + 'fluffco-flat-fitted-sheet-folded-white-1-v2.webp',
    'duvet-cover': CDN + 'fluffco-duvet-cover-folded-tan-bg-1-v2.webp',
    'hotelier-by-fluffco-room-spray': CDN + 'hotelier-tile-tan-v5.webp',
    'down-alternative-comforter': CDN + 'fluffco-down-alternative-comforter-folded-tan-bg-v2.webp',
    'down-blended-comforter-1': CDN + 'fluffco-down-blended-comforter-white-folded-v2.webp',
    'sleep-essentials-bundle': CDN + '2x_1_8bfa7624.jpg',
    'pillow-comforter-kit': CDN + 'PillowComforter_1_b1edc7cb.png',
    '2x-hotel-pillows-pillowcase-set-down-alternative': CDN + '2x_1_8bfa7624.jpg'
  };

  // Short display names for long option values.
  var VLABEL = {
    'Soft Fluff™': 'Soft', 'Firm Fluff™': 'Firm',
    'S / M': 'S/M', 'L / XL': 'L/XL',
    'Standard/Queen': 'Std/Queen', 'One Towel': 'One', 'Two Towels': 'Two',
    'Down Alternative': 'Down Alt', 'St Barths': 'St Barths'
  };
  var OLABEL = { Material: 'Fluff', Quantity: 'Set', Style: 'Color' };

  // ── Single-product cards, in PDF order ─────────────────────────────────────
  var CARDS = [
    { tier: '50', h: 'hotel-pillowcase-set-3', name: 'Hotel Pillowcases', feat: '2-Pack · 300TC combed cotton sateen', per: 2 },
    { tier: '50', h: 'pillow-protectors', name: 'Pillow Protector Set', feat: 'Zippered 2-Pack · Regular or Cooling', isNew: true, per: 2 },
    { tier: '50', h: 'room-spray-1', name: 'Room Spray', feat: 'Signature hotel scents · 250ml' },
    { tier: '50', h: 'linen-spray', name: 'Linen Spray', feat: 'For sheets and towels · 250ml', olabel: { Style: 'Scent' } },
    { tier: '50', h: 'hotel-towel', name: 'Hotel Towel', feat: '600 GSM · 100% cotton' },
    { tier: '50', h: 'travel-pillow', name: 'Travel Pillow', feat: '360° memory foam · Built-in hood', isNew: true },
    { tier: '50', h: 'kids-pillow', name: 'Kids Pillow', feat: 'Kid-sized · Soft Fluff™ feel', isNew: true },

    { tier: '150', h: 'down-alternative-pillow-1', name: 'Down Alternative Pillow', feat: 'Made in USA · Recycled fill', award: 'badge-oprah-sleep-owards-2024_fbcd501c.webp' },
    { tier: '150', h: 'down-feather-pillow', name: 'Down Feather Pillow', feat: 'Ethically sourced · Pillow-in-pillow', award: 'badge-apt-therapy-best-list-back-sleepers_b250f6b3.webp' },
    { tier: '150', h: 'neck-pain-pillow', name: 'Neck Pain Pillow', feat: 'Ergonomic butterfly · Memory foam fill', isNew: true },
    { tier: '150', h: 'silk-pillowcase', name: 'Silk Pillowcase', feat: '22-momme 6A Mulberry silk' },
    { tier: '150', h: 'hotel-waffle-robe', name: 'Hotel Waffle Robe', feat: 'Cotton jacquard · Grey piping' },
    { tier: '150', h: 'hotel-lounge-robe', name: 'Hotel Lounge Robe', feat: 'Coral fleece lined · Shawl collar' },
    { tier: '150', h: 'flat-fitted-sheet', name: 'Flat + Fitted Sheet', feat: '100% combed cotton · Hotel finish' },
    { tier: '150', h: 'duvet-cover', name: 'Duvet Cover', feat: '300 thread count sateen weave' },
    { tier: '150', h: 'hotelier-by-fluffco-room-spray', name: 'Hotelier Room Spray', feat: 'Four 5-star hotel scents · Oversized 250ml', isNew: true },

    { tier: '300', h: 'down-alternative-comforter', name: 'Down Alternative Comforter', feat: 'Cotton + Tencel™ shell' },
    { tier: '300', h: 'down-blended-comforter-1', name: 'Down Blended Comforter', feat: '600 fill power down + Sorona®' },
    { tier: '300', h: 'sleep-essentials-bundle', name: 'Sleep Essentials Bundle', feat: '4 pillows + 4 pillowcases' },
    { tier: '300', h: 'pillow-comforter-kit', name: 'Pillow & Comforter Kit', feat: '1 comforter + 2 pillows' },
    { tier: '300', h: '2x-hotel-pillows-pillowcase-set-down-alternative', name: '2× Pillows & Pillowcases', feat: 'Two pillows + matching cases' }
  ];

  // ── Multi-item sets ────────────────────────────────────────────────────────
  // pickers: [{ key, label, values }] — items bind option slots to '$<key>',
  // a fixed string, or { from: key, map: {...} } for cross-product size names.
  var SETS = [
    { tier: '300', grid: true, name: '2-Piece Hotel Robes', items_label: 'Two Waffle Robes',
      line: 'Two robes, sized independently. One bathroom door, no negotiation.',
      img: 'hotel-waffle-robe',
      pickers: [
        { key: 'r1', label: 'Robe 1', values: ['S / M', 'L / XL'] },
        { key: 'r2', label: 'Robe 2', values: ['S / M', 'L / XL'] }
      ],
      items: [ { h: 'hotel-waffle-robe', o1: '$r1' }, { h: 'hotel-waffle-robe', o1: '$r2' } ] },

    { name: 'The Pillow Thief', items_label: '2× Pillows & Cases',
      line: 'Has genuinely measured a hotel pillow against a carry-on.',
      img: '2x-hotel-pillows-pillowcase-set-down-alternative',
      pickers: [ { key: 'size', label: 'Size', values: ['Standard', 'King'] } ],
      items: [ { h: '2x-hotel-pillows-pillowcase-set-down-alternative', o1: '$size', o2: 'Soft' } ] },

    { name: 'The One That Travels Well', items_label: 'Travel Pillow + Eyemask',
      line: 'Wherever the journey takes you, take better sleep with you.',
      img: 'travel-pillow', pickers: [],
      items: [ { h: 'travel-pillow' }, { h: 'silk-eyemask' } ] },

    { name: 'Has Everything', items_label: 'Hotelier Room Spray',
      line: 'Appreciates the finer notes.',
      img: 'hotelier-by-fluffco-room-spray',
      pickers: [ { key: 'scent', label: 'Scent', values: ['Marrakech', 'Capri', 'St Barths', 'Bali'] } ],
      items: [ { h: 'hotelier-by-fluffco-room-spray', o1: '$scent' } ] },

    { name: 'Woke Up Wrong Again', items_label: 'Neck Pain Pillow',
      line: 'Blames the mattress. It was never the mattress.',
      img: 'neck-pain-pillow', pickers: [],
      items: [ { h: 'neck-pain-pillow' } ] },

    { name: 'First Set of Keys', items_label: 'Pillow + Comforter Kit',
      line: 'New flat, no sheets, one saucepan.',
      img: 'pillow-comforter-kit',
      pickers: [ { key: 'size', label: 'Size', values: ['Standard', 'King'] } ],
      items: [ { h: 'pillow-comforter-kit', o1: '$size', o2: 'Down Alternative' } ] },

    { name: 'Runs Hot at 2am', items_label: 'Comforter + Cooling Protector',
      line: 'One leg out of the duvet, every night, all year.',
      img: 'down-alternative-comforter',
      pickers: [ { key: 'size', label: 'Size', values: ['Queen', 'King'] } ],
      items: [
        { h: 'down-alternative-comforter', o1: '$size' },
        { h: 'pillow-protectors', o1: { from: 'size', map: { 'Queen': 'Standard/Queen', 'King': 'King' } }, o2: 'Cooling' }
      ] },

    { name: 'The Small Guest', items_label: 'Kids Pillow',
      line: 'Four foot nothing and extremely particular.',
      img: 'kids-pillow', pickers: [],
      items: [ { h: 'kids-pillow' } ] }
  ];

  // ── Helpers ────────────────────────────────────────────────────────────────
  // Holiday sale: everything on this page is 20% off the live retail price,
  // rounded to whole dollars. The retail price becomes the strikethrough, and
  // adds stamp _target_total_cents so the cart + checkout Worker charge the
  // sale price exactly (same mechanism as the PDP bundles — and when the
  // sitewide 20% automatic discount launches, the Worker math absorbs it).
  // Sale rate comes from Theme settings (window.FC_SALE); pricing itself is
  // charged by the sitewide automatic discount, so lines carry no targets.
  var SALE_RATE = (window.FC_SALE && window.FC_SALE.enabled && window.FC_SALE.rate > 0) ? window.FC_SALE.rate : 0;
  function salePrice(cents) { return Math.round(cents * (1 - SALE_RATE)); }
  function saleProps(v) {
    var p = { '_fc_gift_guide': '1' };
    if (SALE_RATE > 0) p['_compare_total_cents'] = String(v.p);
    return p;
  }
  function fmt(cents) { return '$' + Math.floor(cents / 100 + 1e-9).toLocaleString('en-US'); } // whole dollars, rounded DOWN (11/3/26)

  // ── Visit attribution (for gift-guide CVR) ───────────────────────────────
  // GA4: fc_gift_guide_view per page view (visitors). Shopify: the cart gets a
  // `gift_guide_visit` attribute, which lands on the order as a note attribute
  // — so ANY order from a session that saw the guide is attributable, not only
  // orders containing gift-guide lines (those also carry _fc_gift_guide props).
  (function trackVisit() {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'fc_gift_guide_view', { page_path: location.pathname }); } catch (e) {}
    var stamp = new Date().toISOString().slice(0, 16).replace('T', ' ');
    try { if (localStorage.getItem('fc_gg_visit')) return; localStorage.setItem('fc_gg_visit', stamp); } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { gift_guide_visit: '1', gift_guide_visit_at: stamp } })
    }).catch(function () {});
  })();
  function vlabel(v) { return VLABEL[v] || v; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function findVariant(h, o1, o2) {
    var p = DATA[h]; if (!p) return null;
    for (var i = 0; i < p.v.length; i++) {
      var v = p.v[i];
      if ((o1 == null || v.o1 === o1) && (o2 == null || v.o2 === o2)) return v;
    }
    return null;
  }

  function addToCart(items, btn) {
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      try { if (typeof window.gtag === 'function') window.gtag('event', 'fc_gift_guide_add', { items: items.length }); } catch (e) {}
      btn.classList.add('is-added');
      btn.textContent = '✓ Added to Cart';
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(null);
      else document.dispatchEvent(new CustomEvent('cart:item-added'));
      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = orig; btn.disabled = false; }, 2400);
    }).catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }

  function pillRow(label, values, sel, onPick, keyAttr) {
    var row = document.createElement('div');
    row.className = 'gg-card__optrow';
    var lab = document.createElement('span');
    lab.className = 'gg-card__optlabel';
    lab.textContent = label;
    row.appendChild(lab);
    values.forEach(function (val) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gg-pill' + (sel() === val ? ' is-on' : '');
      b.textContent = vlabel(val);
      b.setAttribute('data-val', val);
      if (keyAttr) b.setAttribute('data-key', keyAttr);
      b.addEventListener('click', function () {
        onPick(val);
        row.querySelectorAll('.gg-pill').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-val') === val); });
      });
      row.appendChild(b);
    });
    return row;
  }

  // ── Single-product card ────────────────────────────────────────────────────
  function buildCard(cfg) {
    var p = DATA[cfg.h];
    if (!p) return null;
    var state = {};
    var showO1 = p.o1 !== 'Title';
    var o1vals = [], o2vals = [];
    p.v.forEach(function (v) {
      if (v.o1 && o1vals.indexOf(v.o1) < 0) o1vals.push(v.o1);
      if (v.o2 && o2vals.indexOf(v.o2) < 0) o2vals.push(v.o2);
    });
    if (o1vals.length < 2) showO1 = false;
    var showO2 = p.o2 && o2vals.length > 1;
    state.o1 = o1vals[0] || null;
    state.o2 = o2vals[0] || null;

    var el = document.createElement('article');
    el.className = 'gg-card';
    el.innerHTML =
      '<div class="gg-card__media">' +
        '<img src="' + esc(IMG[cfg.h] || '') + '" alt="' + esc(cfg.name) + '" loading="lazy">' +
        '<span class="gg-card__price" data-gg-price></span>' +
        (cfg.isNew ? '<span class="gg-card__new">NEW</span>' : '') +
        (cfg.award ? '<img class="gg-card__award" src="' + CDN + cfg.award + '" alt="">' : '') +
      '</div>' +
      '<div class="gg-card__body">' +
        '<h3 class="gg-card__name">' + esc(cfg.name) + '</h3>' +
        '<p class="gg-card__feat">' + cfg.feat + '</p>' +
        '<div class="gg-card__opts" data-gg-opts></div>' +
        '<div class="gg-card__atc"><button type="button" class="gg-atc" data-gg-atc></button></div>' +
      '</div>';

    var opts = el.querySelector('[data-gg-opts]');
    var priceEl = el.querySelector('[data-gg-price]');
    var atc = el.querySelector('[data-gg-atc]');

    function current() { return findVariant(cfg.h, state.o1, state.o2) || p.v[0]; }
    function sync() {
      var v = current();
      var sale = salePrice(v.p);
      if (cfg.per > 1) {
        priceEl.innerHTML = fmt(sale / cfg.per) + '/per' + (SALE_RATE > 0 ? ' <s>' + fmt(v.p / cfg.per) + '</s>' : '');
      } else {
        priceEl.innerHTML = fmt(sale) + (SALE_RATE > 0 ? ' <s>' + fmt(v.p) + '</s>' : '');
      }
      atc.textContent = v.av ? ('Add to Cart — ' + fmt(sale)) : 'Sold Out';
      atc.disabled = !v.av;
    }
    if (showO1) {
      var l1 = (cfg.olabel && cfg.olabel[p.o1]) || OLABEL[p.o1] || p.o1;
      opts.appendChild(pillRow(l1, o1vals, function () { return state.o1; }, function (v) { state.o1 = v; sync(); }));
    }
    if (showO2) {
      var l2 = (cfg.olabel && cfg.olabel[p.o2]) || OLABEL[p.o2] || p.o2;
      opts.appendChild(pillRow(l2, o2vals, function () { return state.o2; }, function (v) { state.o2 = v; sync(); }));
    }
    atc.addEventListener('click', function () {
      var v = current();
      addToCart([{ id: v.id, quantity: 1, properties: saleProps(v) }], atc);
    });
    sync();
    return el;
  }

  // ── Set card (Guest Register + grid sets) ─────────────────────────────────
  function resolveSet(set, sel) {
    var out = [], total = 0, retail = 0, ok = true;
    set.items.forEach(function (it) {
      function slot(x) {
        if (x == null) return null;
        if (typeof x === 'string') return x.charAt(0) === '$' ? sel[x.slice(1)] : x;
        return x.map[sel[x.from]];
      }
      var v = findVariant(it.h, slot(it.o1), slot(it.o2));
      if (!v || !v.av) { ok = false; return; }
      total += salePrice(v.p);
      retail += v.p;
      out.push({ id: v.id, quantity: 1, properties: saleProps(v) });
    });
    return ok ? { items: out, total: total, retail: retail } : null;
  }

  function buildSet(set) {
    var sel = {};
    set.pickers.forEach(function (pk) { sel[pk.key] = pk.values[0]; });

    var el = document.createElement('article');
    el.className = set.grid ? 'gg-card' : 'gg-set';
    if (set.grid) {
      el.innerHTML =
        '<div class="gg-card__media">' +
          '<img src="' + esc(IMG[set.img] || '') + '" alt="' + esc(set.name) + '" loading="lazy">' +
          '<span class="gg-card__price" data-gg-price></span>' +
        '</div>' +
        '<div class="gg-card__body">' +
          '<h3 class="gg-card__name">' + esc(set.name) + '</h3>' +
          '<p class="gg-card__feat">' + esc(set.line) + '</p>' +
          '<div class="gg-card__opts" data-gg-opts></div>' +
          '<div class="gg-card__atc"><button type="button" class="gg-atc" data-gg-atc></button></div>' +
        '</div>';
    } else {
      el.innerHTML =
        '<div class="gg-set__media"><img src="' + esc(IMG[set.img] || '') + '" alt="" loading="lazy"></div>' +
        '<div class="gg-set__body">' +
          '<div class="gg-set__toprow"><h3 class="gg-set__name">' + esc(set.name) + '</h3><span class="gg-set__price" data-gg-price></span></div>' +
          '<p class="gg-set__items">' + esc(set.items_label) + '</p>' +
          '<p class="gg-set__line">' + esc(set.line) + '</p>' +
          '<div class="gg-set__opts" data-gg-opts></div>' +
          '<div class="gg-set__atc"><button type="button" class="gg-atc" data-gg-atc></button></div>' +
        '</div>';
    }
    var opts = el.querySelector('[data-gg-opts]');
    var priceEl = el.querySelector('[data-gg-price]');
    var atc = el.querySelector('[data-gg-atc]');

    function sync() {
      var r = resolveSet(set, sel);
      if (!r) { priceEl.textContent = '—'; atc.textContent = 'Sold Out'; atc.disabled = true; return; }
      priceEl.innerHTML = fmt(r.total) + (SALE_RATE > 0 ? ' <s>' + fmt(r.retail) + '</s>' : '');
      atc.textContent = (set.items.length > 1 ? 'Add the Set — ' : 'Add to Cart — ') + fmt(r.total);
      atc.disabled = false;
    }
    set.pickers.forEach(function (pk) {
      opts.appendChild(pillRow(pk.label, pk.values, function () { return sel[pk.key]; }, function (v) { sel[pk.key] = v; sync(); }));
    });
    atc.addEventListener('click', function () {
      var r = resolveSet(set, sel);
      if (r) addToCart(r.items, atc);
    });
    sync();
    return el;
  }

  // ── Render ────────────────────────────────────────────────────────────────
  CARDS.forEach(function (cfg) {
    var grid = document.querySelector('[data-gg-grid="' + cfg.tier + '"]');
    var card = buildCard(cfg);
    if (grid && card) grid.appendChild(card);
  });
  SETS.forEach(function (set) {
    if (set.grid) {
      var grid = document.querySelector('[data-gg-grid="' + set.tier + '"]');
      if (grid) grid.appendChild(buildSet(set));
    } else {
      var reg = document.querySelector('[data-gg-register]');
      if (reg) reg.appendChild(buildSet(set));
    }
  });

  // Sticky nav active state
  var navLinks = document.querySelectorAll('[data-gg-nav] a');
  var targets = [];
  navLinks.forEach(function (a) {
    var t = document.querySelector(a.getAttribute('href'));
    if (t) targets.push({ a: a, t: t });
  });
  if ('IntersectionObserver' in window && targets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          navLinks.forEach(function (a) { a.classList.remove('is-active'); });
          var hit = targets.filter(function (x) { return x.t === e.target; })[0];
          if (hit) hit.a.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    targets.forEach(function (x) { io.observe(x.t); });
  }
})();
